// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.information-type-label {\n  font-family: \"Roboto-Medium\", sans-serif;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.375rem;\n  letter-spacing: 0.00714em;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
